import type { KibMultiSelectionOption } from '@chewy/kib-fields-new-react'
import { Utils } from '@pbt/pbt-ui-components'

import type { SuggestionResult } from '~/types'

export const buildUserOption = (
  usersMap: Record<string, { firstName?: string; lastName?: string }>,
  id?: string,
): KibMultiSelectionOption | undefined => {
  if (!id) return undefined
  const user = usersMap[id]
  if (!user) return undefined

  return {
    label: Utils.getPersonString(user),
    value: id,
  }
}

export const mapSuggestionResultsToOptions = (
  searchResults?: SuggestionResult[],
): KibMultiSelectionOption[] => {
  if (!searchResults) return []
  return searchResults.map((result) => ({
    label: result.item ?? '',
    value: result.id,
  }))
}
